import { render, staticRenderFns } from "./LmsSnack.vue?vue&type=template&id=202e601a&scoped=true&"
import script from "./LmsSnack.vue?vue&type=script&lang=js&"
export * from "./LmsSnack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e601a",
  null
  
)

export default component.exports